module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point04_03_activity-8f52dc1ae110cad545dfb432113fc2a3.jpg";